import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthAccountForBusinessUsersError } from '@/core/error/transport/auth/TmAuthAccountForBusinessUsersError'

export const authAccountIsForPersonalUseErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.login,
  subCodes: ['auth.app_for_business_only'],
  klass: TmAuthAccountForBusinessUsersError,
}
